import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';
import {PageableParams} from '@core/models/pageable-params';
import {Observable} from 'rxjs';
import {PageResponse} from '@core/models/page-response';
import {UsuarioInterno} from '@core/models/usuarios';
import {UsuarioLogado} from '@core/models/usuario-logado';

@Injectable({
  providedIn: 'root'
})
export class UsuariosInternosService {
  private readonly uri = environment.api.uri;
  private readonly http = inject(HttpClient)

  get(payload: PageableParams): Observable<PageResponse<UsuarioInterno>> {
    const params = payload.toQueryString();
    return this.http.get<PageResponse<UsuarioInterno>>(`${this.uri}ldap/usuarios-internos?${params}`);
  }

  enable(username: string, enable: boolean): Observable<string> {
    return this.http.patch<string>(`${this.uri}usuario/${username}?ativo=${enable}`, {});
  }

  edit(username: string, perfilId: number): Observable<string> {
    return this.http.patch<string>(`${this.uri}usuario/${username}/perfil?perfilId=${perfilId}`, {});
  }

  getUsuarioLogado(): Observable<UsuarioLogado> {
    return this.http.get<UsuarioLogado>(`${this.uri}usuario/userinfo`);
  }

}
